var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptimization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 41.5254H39.375M10.5 15.9879H7.5C6.46875 15.9879 5.625 16.8316 5.625 17.8629V34.0254C5.625 35.0566 6.46875 35.9004 7.5 35.9004H10.5C11.5312 35.9004 12.375 35.0566 12.375 34.0254V17.8629C12.375 16.8316 11.5312 15.9879 10.5 15.9879ZM24 10.0066H21C19.9687 10.0066 19.125 10.8504 19.125 11.8816V34.0254C19.125 35.0566 19.9687 35.9004 21 35.9004H24C25.0313 35.9004 25.875 35.0566 25.875 34.0254V11.8816C25.875 10.8504 25.0313 10.0066 24 10.0066ZM37.5 4.02539H34.5C33.4687 4.02539 32.625 4.86914 32.625 5.90039V34.0254C32.625 35.0566 33.4687 35.9004 34.5 35.9004H37.5C38.5313 35.9004 39.375 35.0566 39.375 34.0254V5.90039C39.375 4.86914 38.5313 4.02539 37.5 4.02539Z",
    stroke: "#4DFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimization);
export default __webpack_public_path__ + "static/media/optimization.1e90900ecd409c157658793a735a4860.svg";
export { ForwardRef as ReactComponent };